import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { routeTitleFor } from "./routeTitle";

/** The current page's registry title, mirrored into the browser tab's `document.title`. */
export function useRouteTitle(): string {
	const { pathname } = useLocation();
	const title = routeTitleFor(pathname);
	useEffect(() => {
		document.title = title;
	}, [title]);
	return title;
}
